












































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import {
  ReferralTriageDetailsModel,
  RelatedReferralModel,
} from "@/types/aznconnect_api";

import DetailPaneRelatedReferrals from "@/components/DetailPaneRelatedReferrals.vue";
import RawMessageView from "@/components/RawMessageView.vue";
import DebugDataView from "@/components/triage/DebugDataView.vue";
import FileSaver from "file-saver";
import PatientInformationView from "@/components/triage/PatientInformationView.vue";
import ReferralDetailsView from "@/components/triage/ReferralDetailsView.vue";
import GeneralCommentsView from "@/components/triage/GeneralCommentsView.vue";
import ReferralToView from "@/components/triage/ReferralToView.vue";
import ReferralDataView from "@/components/triage/ReferralDataView.vue";
import TriageView from "@/components/triage/TriageView.vue";
import PrescribedMedicationView from "@/components/triage/PrescribedMedicationView.vue";
import MeasuredValuesView from "@/components/triage/MeasuredValuesView.vue";
import MemosRecordedView from "@/components/triage/MemosRecordedView.vue";
import ReferrerInformationView from "@/components/triage/ReferrerInformationView.vue";
import SOEPView from "@/components/triage/SOEPView.vue";
import AlertsView from "@/components/triage/AlertsView.vue";
import AllergyIntolerancesView from "@/components/triage/AllergyIntolerancesView.vue";
import ProfessionalSummaryDetailPane from "@/components/professionalsummary/DetailPane.vue";

@Component({
  components: {
    "detail-pane-related-referrals": DetailPaneRelatedReferrals,
    "raw-message-view": RawMessageView,
    "debug-data-view": DebugDataView,
    "patient-information-view": PatientInformationView,
    "referral-details-view": ReferralDetailsView,
    "general-comments-view": GeneralCommentsView,
    "referral-to-view": ReferralToView,
    "referral-data-view": ReferralDataView,
    "triage-view": TriageView,
    "prescribed-medication-view": PrescribedMedicationView,
    "measured-values-view": MeasuredValuesView,
    "memos-recorded-view": MemosRecordedView,
    "referrer-information-view": ReferrerInformationView,
    "soep-view": SOEPView,
    "alerts-view": AlertsView,
    "allergy-intolerances-view": AllergyIntolerancesView,
    "professional-summary-detail-pane": ProfessionalSummaryDetailPane,
  },
})
export default class TriageDetailPane extends Vue {
  @Prop({ default: null })
  referral!: ReferralTriageDetailsModel;

  @Prop({ default: null })
  relatedReferrals!: RelatedReferralModel[];

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: false })
  allowLinkPatientNumber!: boolean;

  @Prop({ default: false })
  allowSetReferralState!: boolean;

  @Prop({ default: false })
  allowProfessionalSummary!: boolean;

  @Prop({ default: true })
  allowPageClose!: boolean;

  @Prop({ default: "" })
  patientNumber!: string;

  developerMode: boolean = false;
  advancedMode: boolean = false;
  psMode: boolean = false;
  failedToLoad: boolean = false;

  get referallLastUpdateDateTime(): string {
    const referralModel = this.referral as ReferralTriageDetailsModel;

    return `${referralModel.MessageDate} ${referralModel.MessageTime}`;
  }

  copyLinkToClipboard(): void {
    const route = this.$router.resolve({
      name: "referral-details",
      params: { referralId: this.referral.Reference || "" },
    });
    const url = window.location.origin + "/" + route.href;

    var temp = $("<input>");
    $("body").append(temp);
    temp.val(url).select();
    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
    temp.remove();
  }

  toggleDeveloperMode(): void {
    var me = this;
    me.developerMode = !me.developerMode;
  }

  downloadReferral(): void {
    var me = this;

    let model = {
      Action: "DownloadReferralPdf",
      Parameters: { id: me.referral.Reference },
      FileType: "pdf",
    };

    var url = "/FileDownload/RequestDownload";
    AZNCONNECT_API.post(url, model)
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        console.error(
          "Failed to request the download short live token url",
          error,
        );
      });
  }

  toggleAdvancedMode(): void {
    var me = this;
    me.advancedMode = !me.advancedMode;
  }

  closeDetails(): void {
    this.$emit("close");
  }

  mounted() {
    this.$emit("opened");
  }

  destroyed() {
    this.$emit("closed");
  }
}
